<template>
  <div class="frimwareTask-version-box">
    <div class="content-box">
      <div class="search-hd">
        <el-form :inline="true" @submit.native.prevent>
          <!-- 配置项 -->
          <el-form-item style="float: right; margin-right: 0">
            <el-dropdown trigger="click" :hide-on-click="false" @visible-change="saveTableColumn">
              <el-button class="table-set" icon="icon icon-tableset"></el-button>
              <el-dropdown-menu slot="dropdown" class="custom-dropdown">
                <el-dropdown-item>
                  <el-checkbox v-model="isAllColumn" @change="setAllColumn">
                    {{ $t('Common.com_sel_all') }}
                  </el-checkbox>
                </el-dropdown-item>
                <el-dropdown-item v-for="(item, i) in tableColumn" :key="i">
                  <el-checkbox v-model="item.selected" @change="formatTable">
                    {{ item.columnName }}
                  </el-checkbox>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-form-item>
          <el-form-item style="float: right">
            <search-input v-model="formSearch.search" :placeholder="$t('dms_firmwareTask_version.zymczybbxxjrbbh')" @fetch="onPageChange({ page: 1 })"></search-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-bd">
        <!--  type="checkbox" -->
        <custom-table
          ref="table"
          :data="versionList"
          height="100%"
          @input="selectionChange($event, 'versionListSelect')"
          :loading="isLoadingVersion"
          :column="tableColumn"
          :slots="['firmwareCode', 'taskDesc', 'resourceSize','support']"
          @filter="filterChange"
          @sort="sortChange"
        >
        <el-table-column type="selection" :selectable="onSelectable" width="40" slot="prepose"></el-table-column>
          <template v-slot:firmwareCode="scope">
            <!-- <span
              style="color:#00a2df; cursor: pointer"
            >1111111111111111111{{ scope.row.firmwareCode }}</span> -->

            <el-popover placement="top-start" width="400" trigger="click">
              <ul class="popover-content">
                <!-- 签名方法暂无 -->
                <li class="cell-pop-item">{{ $t('dms_firmwareTask_version.qian_ming_fang_fa') }}</li>
                <!-- 固件签名暂无 -->
                <li class="cell-pop-item">{{ $t('dms_firmwareTask_version.gu_jian_qian_ming') }}</li>
                <li class="cell-pop-item">{{ $t('dms_firmwareTask_version.xia_zai_lian_jie') }}{{ scope.row.resourcePath }}</li>
              </ul>
              <span slot="reference" class="firmware-code">{{ scope.row.firmwareCode }}</span>
            </el-popover>
          </template>
          <template v-slot:resourceSize="scope">
            {{ getSourceSize(scope.row.resourceSize) }}
          </template>
          <template v-slot:support="scope">
            <el-popover width="650" placement="bottom" trigger="hover"  v-if="scope.row.machineVersionList">
              <support-protocol-detail :data="scope.row.machineVersionList" tableCode="resource_protocol_detail"></support-protocol-detail>
              <span style="text-align: center; padding: 0 10px" class="table-link" slot="reference">{{ $t('Common.com_detail') }}</span>
            </el-popover>
            <span  style="text-align: center; padding: 0 10px" v-else>{{ $t('Common.com_detail') }}</span>
          </template>
        </custom-table>
      </div>
      <div class="table-page">
        <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" height="300px" @change="onPageChange"></custom-page>
      </div>
      <!-- {{topicCodeList}} -->
      <!-- <div class="params-bd">
        <el-form ref="form" label-position="top" label-width="120px">
          <template>
            <el-form-item v-for="(item, index) in topicCodeList" style="position: relative" :key="index">
              <costomWidget
                v-model="item.paramValue"
                :label="item.dataName"
                :type="item.widgetType"
                :isEditWidget="item.isEditWidget"
                :dicGroup="item.dicGroup"
                :showUnit="item.showUnit"
                :dataLen="item.dataLen"
                width="100%"
              ></costomWidget>
            </el-form-item>
          </template>
        </el-form>
      </div> -->
    </div>
    <div class="btn-group">
      <el-button size="small" @click="onCancel">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="previous">
        {{ $t('dms_firmwareTask_version.sybrwxx') }}
      </el-button>
      <el-button type="primary" @click="nextdevice">
        {{ $t('dms_firmwareTask_version.xybxzsb') }}
      </el-button>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import supportProtocolDetail from '@/pages/dms/components/support_protocol_detail';

export default {
  props: {
    model: {
      type: Object,
      default() {
        return {
          type: '', // add、edit
          title: '',
        };
      },
    },
    value: {
      type: Boolean,
      default: false,
    },
    data: [String, Object, Array],
    taskId: [String, Number],
    resourceId: [String, Number],
  },
  components: { supportProtocolDetail },
  data() {
    return {
      tableCode: 'firmware_version',
      formSearch: {
        search: '',
        taskName: '',
        pageSize: 50,
        pageNum: 1,
        protocolId: '',
        tcpVersion: '',
        state: 1
      },
      isLoadingVersion: false,
      versionList: [],
      totalRows: null,
      versionListSelect: [],
      tableColumnVersion: null,
      // 新  参数配置
      topicCodeList: [],

      iot_tsl_data_unit: {},
    };
  },
  mounted() {
    this.getTableColumn();
    this.getSteps2();
    this.getTslCodeList();
    this.getDictionary('iot_tsl_data_unit', (data) => {
      this.iot_tsl_data_unit = this.$transformDicValue(data.iot_tsl_data_unit);
    });
  },
  methods: {
    // 表格禁用行
    onSelectable: function (row) {
      return !row[this.selectableKey];
    },
    onCancel() {
      this.jump('/iot/firmwareTask');
    },
    getSourceSize(val) {
      if (typeof val === 'number') {
        return (val / 1024).toFixed(2);
      }
      return '';
    },
    getSteps2: function () {
      this.isLoadingVersion = true;
      // 获取表格列
      this.formSearch.protocolCode = this.data.protocolCode;
      // this.formSearch.tcpVersion = this.data.tcpVersion;
      // 第二步选择合同
      this.$getJSON(apis.resourcePage, this.formSearch).then((res) => {
        this.isLoadingVersion = false;
        this.versionList = res.data.list;
        this.totalRows = res.data.total;
        if (this.resourceId) {
          this.$nextTick(function () {
            const selectIndex = this.versionList.find(item => item.resourceId === this.resourceId);
            this.$refs.table.$emit('toggleRowSelection', selectIndex, true);
            this.versionListSelect = [selectIndex];
            this.setTopicCode();
          });
        }
      });
    },
    // 获取所有参数值
    getTslCodeList: function () {
      this.$getJSON(apis.commandTaskTslDataList, {
        // topicId: this.data.topicId,
        // protocolId: this.data.protocolId,
        taskId: this.taskId,
        // 新
        productCode: this.data.productCode,
        tcpVersion: this.data.tcpVersion,
        topicCode: this.data.topicCode,
      }).then((res) => {
        res.data.forEach((item) => {
          item.widgetType = item.widgetType || '1';
          // 先取 参数值  后去默认值
          item.paramValue = item.dataValue ? item.dataValue : item.defaultValue || '';
        });
        this.topicCodeList = res.data;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getSteps2();
    },
    // 表格选中变更
    selectionChange: function (val, name) {
      // console.log(val);
      if (val.length > 1) {
        this.$refs.table.$refs.tb1.clearSelection();
        const select = val.pop();
        this.$refs.table.$refs.tb1.toggleRowSelection(select);
        this[name] = [select];
        // this.name = [];
        // this[name] = val;
      } else {
        // this.name = [];
        this[name] = val;
      }
      this.$nextTick(() => {
        this.setTopicCode();
      });
    },
    setTopicCode(data) {
      if (data) {
        this.topicCodeList.forEach((item) => {
          switch (item.dataCode) {
            case 'module':
              item.paramValue = data.find(i => i.dataCode === 'module').paramValue;
              // item.paramValue = 'vcu';
              break;
            case 'version':
              item.paramValue = data.find(i => i.dataCode === 'version').paramValue;
              break;
            case 'size':
              item.paramValue = data.find(i => i.dataCode === 'size').paramValue;
              break;
            case 'url':
              item.paramValue = data.find(i => i.dataCode === 'url').paramValue;
              break;
            case 'sign':
              item.paramValue = data.find(i => i.dataCode === 'sign').paramValue;
              break;
            case 'signMethod':
              item.paramValue = data.find(i => i.dataCode === 'signMethod').paramValue;
              break;
          }
        });
      } else {
        // 暂时只会走这里
        this.topicCodeList.forEach((item) => {
          switch (item.dataCode) {
            // 没有paramValue 定义值
            case 'resourceClass':
              item.paramValue = this.versionListSelect[0].resourceClass;
              // item.paramValue = 'vcu';
              break;
            case 'resourceType':
              item.paramValue = this.versionListSelect[0].resourceType;
              // item.paramValue = 'vcu';
              break;
            case 'module':
              item.paramValue = this.versionListSelect[0].tcpModule;
              // item.paramValue = 'vcu';
              break;
            case 'version':
              item.paramValue = this.versionListSelect[0].resourceVersion;
              break;
            case 'size':
              item.paramValue = this.versionListSelect[0].attachSize;
              break;
            case 'url':
              item.paramValue = this.getAttachUrl(this.versionListSelect[0]);
              break;
            case 'signMethod':
              item.paramValue = this.versionListSelect[0].signMethod;
              break;
            case 'name':
              item.paramValue = this.versionListSelect[0].attachName;
              break;
            case 'signKey':
              item.paramValue = this.versionListSelect[0].signKey;
              break;

            // attachHumanSize: "263.0k"
            // attachId: "669148352557944832"
            // attachName: "ice1000_comm-aprom-beta211215-2.0.bin"
            // attachPath: "test/ist/firmware/6CCE347C894C4D3DAE313EF93B12CDF4.bin"
            // attachSize: 2631001
            // attachSuffix: ""
            // creator: "李委托"
            // creatorId: "493036637977772032"
            // gmtCreate: "2021-12-17 01:17:45"
            // gmtModified: "2021-12-17 01:17:45"
            // modifier: ""
            // protocolClass: "RBT"
            // resourceClass: 1
            // resourceCode: "211217000002"
            // resourceDesc: ""
            // resourceId: "669148352764534784"
            // resourceName: "ice1000-beta211215-2.0"
            // resourceType: "modem"
            // resourceVersion: "211215"
            // state: 1
            // supportPreVersion: ""
            // tcpModule: 3
          }
        });
      }
    },
    previous: function () {
      this.$emit('previous');
    },
    nextdevice: function () {
      if (this.versionListSelect.length === 0) {
        const tips = this.$t('dms_firmwareTask_version.qxzrwzybb');
        this.$message.error(tips);
      } else {
        // const parameter = this.data || {};
        const parameter = {};
        parameter.resourceId = this.versionListSelect[0].resourceId;
        parameter.firmwareVersion = this.versionListSelect[0].firmwareVersion;
        parameter.supportPreVersion = this.versionListSelect[0].supportPreVersion;
        parameter.resourceId = this.versionListSelect[0].resourceId;
        parameter.resourceClass = this.versionListSelect[0].resourceClass;
        parameter.resourceType = this.versionListSelect[0].resourceType;
        parameter.taskId = this.taskId;

        // 固件类型用于第三步下拉 固件版本号 (暂时不加有待确定)
        // const firmwareType = this.versionListSelect[0].firmwareType;

        this.$postJSON(apis.commandTaskUpdate, parameter).then(() => {
          // this.tabActive = 3;
          // this.$emit('OnFirmwareType', firmwareType);

          // 保存参数
          // 数据转换
          this.topicCodeList.forEach((i) => {
            // i.paramKey = this.form.tslCode;
            // i.paramName = i.dataName;
            // i.paramValue = i.paramValue;
            i.taskId = this.taskId;
            i.paramKey = i.dataCode;
            i.paramName = i.dataName;
            // paramValue
            i.paramValue = i.paramValue;
            i.langParamName = i.langDataName;
            i.isPrimary = i.isPrimary;
            i.isYearKey = i.isYearKey;
            if (i.dataValue) {
              i.dataValue = Number(i.dataValue);
            }
            // i.tslCode = this.form.tslCode;
          });

          this.$postJSON(apis.commandTaskParamSave, {
            taskId: this.taskId,
            // tslId: 455387929271324672,
            taskOrders: this.topicCodeList,
          }).then(() => {
            this.$emit('success', 3);
            this.$emit('changeresourceId', this.versionListSelect[0].resourceId);
          });
        });
      }
    },
  },
};
</script>

<style lang="scss">
.frimwareTask-version-box {
  display: flex;
  height: 100%;
  background-color: #ffffff;
  flex-direction: column;

  box-sizing: border-box;
  .content-box {
    flex: 1;
    overflow-y: auto;
    display: flex;
    padding: 0 24px;
    flex-direction: column;
  }
  .params-bd {
    flex: 1;
    overflow: hidden;
    overflow-y: auto;
  }
  .btn-group {
    border-top: 1px solid #eef2f8;
    padding: 16px 0 16px 24px;
    height: 60px;
    z-index: 1;
    -webkit-box-flex: 0;
    flex: 0 0 60px;
  }

  .firmware-code {
    text-decoration: underline;
  }
}
</style>
